import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";

@Component({
  selector: "app-prefix-ba3",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-ba3.component.html",
  styleUrl: "./prefix-ba3.component.less",
})
export class PrefixBa3Component extends PrefixTextComponent {
  public constructor() {
    super();
    this.post = false;
    this.hide = true;
    this.characters = ALLOWED_CHARACTERS["ba3"];
  }
}
